import {
  DEFAULT_USER_PREFERENCES,
  type UserPreferences,
  type UserProfileResponse,
} from "@/domain/user";
import { InvalidationEntity } from "../entityDependencies";
import { queryKeys } from "../queryKeys";
import { detailSlot, isObject } from "../cache/cacheSlots";
import { defineEntityCache } from "../cache/entityCache";

/** The signed-in user is the only record: every patch addresses it. */
export const CURRENT_USER = "current";

/** The user belongs to no organization. */
export const NO_ORGANIZATION = "";

export interface UserPatch {
  profile?: Partial<UserProfileResponse>;
  preferences?: Partial<UserPreferences>;
}

function isProfile(value: unknown): value is UserProfileResponse {
  return isObject(value) && typeof value.uuid === "string" && typeof value.email === "string";
}

export const userCache = defineEntityCache<string, UserPatch>({
  entity: InvalidationEntity.USER,
  slots: () => [
    detailSlot({
      prefix: queryKeys.userProfile.current(),
      isRecord: isProfile,
      idOf: () => CURRENT_USER,
      merge: (current, { profile, preferences }) => ({
        ...current,
        ...profile,
        ...(preferences
          ? {
              preferences: { ...(current.preferences ?? DEFAULT_USER_PREFERENCES), ...preferences },
            }
          : {}),
      }),
    }),
  ],
  records: () => [queryKeys.userProfile.current()],
});
